/**
 * @generated SignedSource<<3e3daaab7700fabddca40064140a3341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobActivityTimelineListRefetchQuery$variables = {
  id: string;
};
export type JobActivityTimelineListRefetchQuery$data = {
  readonly job: {
    readonly " $fragmentSpreads": FragmentRefs<"JobActivityTimelineList_job">;
  } | null;
};
export type JobActivityTimelineListRefetchQuery = {
  response: JobActivityTimelineListRefetchQuery$data;
  variables: JobActivityTimelineListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Cluster",
  "kind": "LinkedField",
  "name": "cluster",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v6/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "JobConcurrency",
  "kind": "LinkedField",
  "name": "concurrency",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "group",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exitStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionHasKnownIssues",
  "storageKey": null
},
v16 = [
  (v3/*: any*/),
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ClusterQueue",
  "kind": "LinkedField",
  "name": "clusterQueue",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Cluster",
      "kind": "LinkedField",
      "name": "cluster",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = [
  (v5/*: any*/)
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signal",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalReason",
  "storageKey": null
},
v22 = [
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JobActivityTimelineListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobActivityTimelineList_job"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JobActivityTimelineListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJob"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JobPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "number",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "agentQueryRules",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClusterQueue",
                "kind": "LinkedField",
                "name": "clusterQueue",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dispatchPaused",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dispatchPausedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "dispatchPausedBy",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dispatchPausedNote",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matrix",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StepCommand",
                "kind": "LinkedField",
                "name": "step",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "conditional",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "DependencyConnection",
                    "kind": "LinkedField",
                    "name": "dependencies",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Dependency",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v8/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "dependencies(first:30)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "JobEventConnection",
                "kind": "LinkedField",
                "name": "events",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobEventEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJobEvent"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timestamp",
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JobTypeCommand",
                            "kind": "LinkedField",
                            "name": "job",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "softFailed",
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v17/*: any*/),
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "heartbeatAt",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "JobEventActor",
                            "kind": "LinkedField",
                            "name": "actor",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Avatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "User",
                                    "abstractKey": null
                                  },
                                  (v19/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v18/*: any*/),
                                    "type": "Dispatch",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v17/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hostname",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isDeprecated",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OperatingSystem",
                                        "kind": "LinkedField",
                                        "name": "operatingSystem",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Agent",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/)
                            ],
                            "type": "JobEventFinished",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobRetryRuleAutomatic",
                                "kind": "LinkedField",
                                "name": "automaticRule",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobTypeCommand",
                                "kind": "LinkedField",
                                "name": "retriedInJob",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventRetried",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "errorDetail",
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventStackError",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventStackNotification",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "detail",
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventStackFinished",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "assignedAgent",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v17/*: any*/),
                                  (v6/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventAssigned",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JobEventCanceled",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v22/*: any*/),
                            "type": "JobEventTimedOut",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "changedChanges",
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventChanged",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuildStepUpload",
                                "kind": "LinkedField",
                                "name": "buildStepUpload",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuildStepUploadDefinition",
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "yaml",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventBuildStepUploadCreated",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "changedPriorityBeforeValue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "changedPriorityAfterValue",
                                "storageKey": null
                              }
                            ],
                            "type": "JobEventReprioritized",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "retryFailedReason",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "JobEventRetryFailed",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "JobEvent",
                                "abstractKey": "__isJobEvent"
                              }
                            ],
                            "type": "JobEventRetryFailed",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "events(first:30)"
              }
            ],
            "type": "JobTypeCommand",
            "abstractKey": null
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56f9f04027ac3cb0efec2d08185d4282",
    "id": null,
    "metadata": {},
    "name": "JobActivityTimelineListRefetchQuery",
    "operationKind": "query",
    "text": "query JobActivityTimelineListRefetchQuery(\n  $id: ID!\n) {\n  job(uuid: $id) {\n    __typename\n    ...JobActivityTimelineList_job\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AgentBadge_agent on Agent {\n  name\n  uuid\n  version\n  versionHasKnownIssues\n  clusterQueue {\n    id\n    uuid\n    cluster {\n      uuid\n      id\n    }\n  }\n  organization {\n    slug\n    id\n  }\n}\n\nfragment AgentUpgradeBanner_agent on Agent {\n  version\n}\n\nfragment JobActivityTimelineList_job on Job {\n  __isJob: __typename\n  ... on JobTypeCommand {\n    uuid\n    state\n    createdAt\n    ...JobEventCreated_job\n    events(first: 30) {\n      edges {\n        node {\n          __typename\n          uuid\n          __isJobEvent: __typename\n          timestamp\n          type\n          ...JobEventLimited_event\n          ...JobEventFinished_event\n          ...JobEventRetried_event\n          ...JobEventScheduled_event\n          ...JobEventReserved_event\n          ...JobEventReservedExpired_event\n          ...JobEventStackErrored_event\n          ...JobEventStackNotification_event\n          ...JobEventStackFinished_event\n          ...JobEventAssigned_event\n          ...JobEventAssignedExpired_event\n          ...JobEventCanceled_event\n          ...JobEventCancelation_event\n          ...JobEventAccepted_event\n          ...JobEventAcceptedExpired_event\n          ...JobEventStarted_event\n          ...JobEventTimedOut_event\n          ...JobEventChanged_event\n          ...JobEventBuildStepUploadCreated_event\n          ...JobEventExpired_event\n          ...JobEventAgentStopped_event\n          ...JobEventAgentDisconnected_event\n          ...JobEventAgentLost_event\n          ...JobEventJobLogSizeExceeded_event\n          ...JobEventReprioritized_event\n          ...JobEventRetryFailed_event\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JobEventAcceptedExpired_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventAccepted_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ...AgentUpgradeBanner_agent\n      ... on Agent {\n        hostname\n        version\n        versionHasKnownIssues\n        isDeprecated\n        operatingSystem {\n          name\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventAgentDisconnected_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventAgentLost_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventAgentStopped_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventAssignedExpired_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventAssigned_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  ... on JobEventAssigned {\n    assignedAgent {\n      ...AgentBadge_agent\n      id\n    }\n  }\n  actor {\n    type\n  }\n}\n\nfragment JobEventBuildStepUploadCreated_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventBuildStepUploadCreated {\n    buildStepUpload {\n      definition {\n        yaml\n      }\n      id\n    }\n  }\n}\n\nfragment JobEventCancelation_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    node {\n      __typename\n      ... on User {\n        name\n        ...UserAvatar_user\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventCanceled_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  ... on JobEventCanceled {\n    exitStatus\n  }\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Agent {\n        name\n        uuid\n        organization {\n          slug\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment JobEventChanged_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    type\n    node {\n      __typename\n      ... on User {\n        name\n        uuid\n        ...UserAvatar_user\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventChanged {\n    changedChanges\n  }\n}\n\nfragment JobEventCreated_job on JobTypeCommand {\n  uuid\n  createdAt\n  priority {\n    number\n  }\n  agentQueryRules\n  cluster {\n    name\n    uuid\n    organization {\n      slug\n      id\n    }\n    id\n  }\n  clusterQueue {\n    key\n    uuid\n    dispatchPaused\n    dispatchPausedAt\n    dispatchPausedBy {\n      name\n      id\n    }\n    dispatchPausedNote\n    cluster {\n      name\n      uuid\n      organization {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n  concurrency {\n    group\n    limit\n  }\n  matrix\n  step {\n    uuid\n    key\n    conditional\n    dependencies(first: 30) {\n      count\n      edges {\n        node {\n          uuid\n          key\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment JobEventExpired_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventFinished_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  ... on JobEventFinished {\n    exitStatus\n    signal\n    signalReason\n  }\n  actor {\n    type\n  }\n  job {\n    softFailed\n    exitStatus\n    agent {\n      ...AgentBadge_agent\n      heartbeatAt\n      id\n    }\n    id\n  }\n}\n\nfragment JobEventJobLogSizeExceeded_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventLimited_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  job {\n    concurrency {\n      group\n      limit\n    }\n    id\n  }\n}\n\nfragment JobEventReprioritized_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    type\n    node {\n      __typename\n      ... on User {\n        name\n        uuid\n        ...UserAvatar_user\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventReprioritized {\n    changedPriorityBeforeValue\n    changedPriorityAfterValue\n  }\n}\n\nfragment JobEventReservedExpired_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventReserved_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventRetried_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  actor {\n    type\n    node {\n      __typename\n      ... on User {\n        name\n        uuid\n        ...UserAvatar_user\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n  ... on JobEventRetried {\n    automaticRule {\n      exitStatus\n      signal\n      signalReason\n      limit\n    }\n    retriedInJob {\n      uuid\n      id\n    }\n  }\n}\n\nfragment JobEventRetryFailed_event on JobEventRetryFailed {\n  ... on JobEvent {\n    __isJobEvent: __typename\n    timestamp\n    actor {\n      type\n      node {\n        __typename\n        ... on User {\n          name\n          uuid\n          ...UserAvatar_user\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on Dispatch {\n          id\n        }\n      }\n    }\n    ... on JobEventRetryFailed {\n      retryFailedReason\n    }\n  }\n}\n\nfragment JobEventScheduled_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n}\n\nfragment JobEventStackErrored_event on JobEvent {\n  __isJobEvent: __typename\n  uuid\n  timestamp\n  ... on JobEventStackError {\n    errorDetail\n  }\n}\n\nfragment JobEventStackFinished_event on JobEvent {\n  __isJobEvent: __typename\n  uuid\n  timestamp\n  ... on JobEventStackFinished {\n    detail\n  }\n}\n\nfragment JobEventStackNotification_event on JobEvent {\n  __isJobEvent: __typename\n  uuid\n  timestamp\n  ... on JobEventStackNotification {\n    message\n  }\n}\n\nfragment JobEventStarted_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  job {\n    agent {\n      ...AgentBadge_agent\n      id\n    }\n    id\n  }\n}\n\nfragment JobEventTimedOut_event on JobEvent {\n  __isJobEvent: __typename\n  timestamp\n  ... on JobEventTimedOut {\n    exitStatus\n  }\n  actor {\n    node {\n      __typename\n      ...AgentBadge_agent\n      ... on Agent {\n        name\n        uuid\n        organization {\n          slug\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      ... on Dispatch {\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar_user on User {\n  name\n  avatar {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "05c73d93982b966e679b89cf65e7bf2c";

export default node;
